//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsPayPalPayLater} from '@nuskin/product-components';
import {parseOktaObject} from '../utils';

export default {
  name: 'ProductActions',
  components: {NsPayPalPayLater},
  props: {
    points: {
      type: Object,
      default: () => ({})
    },
    showPoints: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    purchaseType: {
      type: String,
      default: ''
    },
    statusKey: {
      type: String,
      default: ''
    },
    statusType: {
      type: String,
      default: ''
    },
    statusMessage: {
      type: String,
      default: ''
    },
    canUserShop: {
      type: Boolean,
      default: true
    },
    quantity: {
      type: Number,
      default: 1
    },
    maxQuantity: {
      type: Number,
      default: 0
    },
    backorderQuantity: {
      type: Number,
      default: 0
    },
    backorderAvailableDate: {
      type: String,
      default: null
    },
    marketAttributes: {
      type: Object,
      required: true
    },
    currencyCode: {
      type: String,
      default: ''
    },
    selectedBundleVariants: {
      type: Array,
      default: () => []
    },
    sku: {
      type: String,
      default: ''
    },
    isWholesale: {
      type: Boolean,
      default: false
    },
    /**
     * If true:
     * Display the subscription pricing from the graphql
     * Change the “Subscribe Monthly” button text to be the “Subscribe And Save”
     * text (common strings - product.subscribeAndSave)
     */
    subscribeAndSave: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantityValue: 1,
      totalPrice: +this.price * this.quantity,
      accessToken: parseOktaObject(sessionStorage.oktaTokens)
    };
  },
  computed: {
    currencyLocale() {
      return this.$store.getters['nuskin/currencyLocale'] || '';
    },
    marketConfig() {
      return this.$store.state.nuskin.marketConfig || {};
    },
    totalAmount() {
      return this.formatCurrency(this.totalPrice);
    },
    showPayLater() {
      return !!this.marketConfig.enablePayPalText && this.totalPrice > 0;
    },
    maxAvailable() {
      return +this.maxQuantity > 0 ? +this.maxQuantity : 0;
    },
    disableAction() {
      if (
        !this.canUserShop ||
        !['releasedForSale', 'onBackorder'].includes(this.statusKey)
      ) {
        return true;
      }
      if (
        this.statusKey === 'onBackorder' &&
        this.quantityValue < this.maxAvailable &&
        new Date(this.backorderAvailableDate + ' ') > new Date()
      ) {
        return false;
      }
      if (this.quantityValue > this.maxAvailable) {
        return true;
      }
      return false;
    },
    displayPoint() {
      return this.showPoints && this.points && this.points.pv;
    }
  },
  watch: {
    quantity(value) {
      this.quantityValue = value;
      this.updateTotal();
    },
    quantityValue(value) {
      if (value !== this.quantity) {
        this.$emit('quantity-change', value);
        this.$emit('bundle-update', {bundleQuantity: value});
      }
    },
    price() {
      this.updateTotal();
    },
    purchaseType() {
      this.updateTotal();
    }
  },
  methods: {
    handleAction() {
      this.$emit('add-to-cart', this.purchaseType);
    },

    formatCurrency(value) {
      if (!this.currencyCode || !this.currencyLocale) {
        console.warn(
          `[Catalog] Currency unknown. Code ['USD']: '${this.currencyCode}', Locale ['en-US']: '${this.currencyLocale}'.`
        );
      }
      return Intl.NumberFormat(this.currencyLocale || 'en-US', {
        style: 'currency',
        currency: this.currencyCode || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(typeof value === 'object' ? 0 : value || 0);
    },

    updateTotal() {
      if (
        this.selectedBundleVariants &&
        (this.selectedBundleVariants || []).length > 0
      ) {
        this.totalPrice = this.price; // quantity already factored in by parent ProductDetail.vue via bundleUpdate()
      } else {
        this.totalPrice = +this.price * this.quantity;
      }
    }
  }
};
